import { Upload } from "lucide-react";

export default function BulkDropzone({ file, inputRef, onFileChange, onClick }) {
  return (
    <div
      data-testid="bulk-dropzone"
      onClick={onClick}
      className="bg-white border-2 border-dashed border-border/70 hover:border-[#1A3626] transition-colors rounded-2xl p-10 text-center cursor-pointer"
    >
      <div className="mx-auto h-14 w-14 rounded-xl bg-[#F4F5F4] flex items-center justify-center mb-4">
        <Upload className="h-6 w-6 text-[#1A3626]" strokeWidth={1.5} />
      </div>
      <div className="font-heading text-xl tracking-tight mb-2">
        {file ? file.name : "Click to pick a CSV"}
      </div>
      <div className="text-sm text-[#5B695E]">
        Max a few thousand rows. Header row allowed.
      </div>
      <input
        ref={inputRef}
        type="file"
        accept=".csv,text/csv"
        onChange={onFileChange}
        className="hidden"
        data-testid="bulk-file-input"
      />
    </div>
  );
}
